import React from 'react'
import { IObject } from 'interfaces'
import { StyleSheet, View, Text } from 'react-native'
import BaseObject, { BaseObjectProps } from '../BaseObject'
import TableScroll from './TableScroll'
import { getBindingData } from './utils'
import { BindingDataItem, Field } from './TableTypes'
import TableRow, { Row } from './TableRow'

type TableAttributes = {
  attributes: {
    fields: Field[]
  }
}

interface TableProps extends BaseObjectProps {
  bindingData: BindingDataItem[]
  object: IObject & TableAttributes
}

export default class Table extends BaseObject<TableProps> {
  getTableData() {
    const { bindingData, object } = this.props
    const fields = object?.attributes.fields

    if (bindingData && fields) {
      return getBindingData(fields, bindingData)
    }

    return { columns: [], data: [] }
  }

  renderTable() {
    const { columns, data } = this.getTableData()

    if (columns.length === 0 || data.length === 0) {
      return null
    }

    const isLastRow = (index: number) => index === data.length - 1

    return (
      <View style={styles.tableContainer}>
        <TableScroll horizontal>
          <View>
            <View style={styles.header}>
              {columns.map(col => (
                <View style={styles.headerCell} key={col}>
                  <Text style={styles.headerText}>{col}</Text>
                </View>
              ))}
            </View>
            {data.map((rowData: Row, rowIndex: number) => (
              <TableRow
                key={rowData.id}
                data={rowData}
                isLastRow={isLastRow(rowIndex)}
                rowIndex={rowIndex}
              />
            ))}
          </View>
        </TableScroll>
      </View>
    )
  }

  render() {
    return <View style={styles.container}>{this.renderTable()}</View>
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    paddingTop: 30,
    backgroundColor: '#fff',
    flexDirection: 'column',
  },
  tableContainer: {
    flexDirection: 'row',
    borderRadius: 10,
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 5,
    elevation: 5,
    backgroundColor: '#fff',
  },
  header: {
    flexDirection: 'row',
    backgroundColor: '#F5F5F5',
    height: 50,
    alignItems: 'center',
  },
  headerCell: {
    backgroundColor: '#F6F6F6',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
  },
  headerText: {
    fontWeight: 'bold',
    color: '#333',
  },
  disabledText: {
    color: '#ccc',
  },
})
